(function() {
  'use strict';

  angular.module('app').controller('FeedbackWizardController', FeedbackWizardController);

  FeedbackWizardController.$inject = [
    '$rootScope',
    '$scope',
    '$routeParams',
    '$location',
    '$timeout',
    '$translate',
    '$filter',
    '$uibModal',
    'blockUI',
    'LANGS',
    'BusinessService',
    'FeedbackService',
    'LoyaltyService',
    'NotifyService',
    'SelectService',
    'SettingsService',
    'UserService'
  ];

  function FeedbackWizardController(
      $rootScope,
      $scope,
      $routeParams,
      $location,
      $timeout,
      $translate,
      $filter,
      $uibModal,
      blockUI,
      LANGS,
      BusinessService,
      FeedbackService,
      LoyaltyService,
      NotifyService,
      SelectService,
      SettingsService,
      UserService) {

    /**
     * Модель с полями для создания бизнеса
     */
    $scope.createBusinessModel = {
      country: $rootScope.USER.country,
      business_type: 'customers-feedback',
      time_zone: 'GMT'
    };

    /**
     * Модель с полями для создания источника отзывов
     */
    $scope.createFeedbackSourceModel = {
      customer_actions: 'rate-and-review'
    };

    /**
     * Модель с полями для редактирования информации о бренде
     * @type {{email: string}}
     */
    $scope.changeLoyaltyModel = {
      email: ''
    };

    $scope.resendEmailModel = {
      email: ''
    };

    $scope.loyaltiesList = {};

    $scope.data = {
      possibleCustomerActions: FeedbackService.possibleCustomerActions
    };

    /**
     * Этап визарда
     * 0 - создание бизнеса
     * 1 - создание источника отзывов
     * 2 - завершение, информация о ссылке и qr-коде
     * @type {number}
     */
    $scope.step = 0;

    /**
     * Сообщение об ошибке
     * @type {string}
     */
    $scope.inlineMessage = '';

    $scope.finalFeedbackSourceData = {};

    $scope.getCountriesList = SelectService.getCountriesList;
    $scope.getTimezonesList = SelectService.getTimezonesList;
    $rootScope.PAGE.style = 'no-menu bg-white';

    var block_wizard = blockUI.instances.get('wizard');

    $scope.isURLValid = isURLValid;

    function initController() {
      $rootScope.LANG = $translate.use();
      $scope.getCountriesList();

      $scope.changeLoyaltyModel.email = $rootScope.USER.login;
      $scope.resendEmailModel.email = $rootScope.USER.login;

      if (!$scope.createBusinessModel.country) {
        SettingsService.CurrentCountry(function(success, response) {
          $scope.createBusinessModel.country = response.code;
        });
      }
      if (!$rootScope.ENV.business.tariff) {
        $scope.step = 0;
      } else {
        goToFeedbackSources();
      }

    }

    function goToFeedbackSources() {
      $uibModal.open({
        animation: true,
        keyboard: false,
        backdrop: 'static',
        templateUrl: 'app/templates/modal.feedback-wizard-already-registered.html',
        controllerAs: 'registeredModal',
        controller: function($uibModalInstance) {
          var popup = this;
          popup.goToSources = function() {
            $uibModalInstance.close();
            $location.path('/feedback/sources');
          };
        }
      });
    }

    $scope.nextStepHandler = function() {
      $scope.inlineMessage = '';
      switch ($scope.step) {
          /**
           * Создание бизнеса. Вместе с ним создается бренд
           */
        case 0:
          block_wizard.start();
          if ($scope.form.title.$valid) {
            var businessCreateParams = angular.copy($scope.createBusinessModel);
            businessCreateParams.rate = null;
            businessCreateParams.refferal_code = null;
            businessCreateParams.rate_type = null;
            BusinessService.Create(businessCreateParams, function(success, data) {
              if (success) {
                $rootScope.hideWarnings = true;
                // Подставляем емейл, который пользователь указал при регистрации
                UserService.Profile(function(success, user) {
                  if (success) {
                    $scope.changeLoyaltyModel.email = user.login;
                  }
                });
                // Получаем бренд для дальнейшего редактирование информации в нем
                LoyaltyService.All(function(success, data) {
                  if (success) {
                    $scope.loyaltiesList = angular.copy(data);
                    $scope.inlineMessage = '';
                    $scope.step++;
                  } else {
                    $scope.inlineMessage = data.message;
                  }
                  block_wizard.stop();
                });
              } else {
                if ([1, 2, 62].indexOf(data.code) !== -1) {
                  $scope.inlineMessage = data.message;
                }
                block_wizard.stop();
              }
            });

          } else {
            $scope.form.title.$dirty = true;
            $scope.inlineMessage = 'Please, check if all data are correct.';
            block_wizard.stop();
          }
          break;
          /**
           * Создание источника отзывов и включение отзывов
           */
        case 1:
          block_wizard.start();
          // Получаем информацию о бренде и добавляем емейл в информацию о нем
          LoyaltyService.Get($scope.loyaltiesList[0].id, function(success, data) {
            if (success) {
              // Добавление емейла
              var changeLoyaltyParams = data;
              changeLoyaltyParams.links = {
                email: $scope.changeLoyaltyModel.email
              };
              changeLoyaltyParams.legal_info = {};
              changeLoyaltyParams.legal_info[$rootScope.LANG] = $scope.changeLoyaltyModel.legal_info;
              changeLoyaltyParams.privacy_policy_url = {};
              changeLoyaltyParams.privacy_policy_url[$rootScope.LANG] = $scope.changeLoyaltyModel.privacy_policy_url;

              LoyaltyService.Change($scope.loyaltiesList[0].id, changeLoyaltyParams, function(success, data) {
                if (!success) {
                  $scope.inlineMessage = data.message;
                }
              });
              // Создание источника отзывов
              var createFeedbackSourceParams = angular.copy($scope.createFeedbackSourceModel);
              createFeedbackSourceParams.public_title = {};
              createFeedbackSourceParams.public_title[$rootScope.LANG] = createFeedbackSourceParams.public_title_nm;
              delete createFeedbackSourceParams.public_title_nm;
              FeedbackService.addFeedbackSource($scope.loyaltiesList[0].id, createFeedbackSourceParams, function(success, response) {
                if (success) {
                  var feedbackSource = response;
                  // Включаем возможность оставлять отзывы для бренда
                  var enableFeedbackParams = {
                    active: 1,
                    allow_attach_file_for_unauthorized_customer: 1,
                    allow_rating_for_unauthorized_customer: 1,
                    allow_review_for_unauthorized_customer: 1,
                    chatbot_feedback_allowed: 'none',
                    feedback_per_customer_limit: 0,
                    feedback_source_id: feedbackSource.id,
                    loyalty_id: $scope.loyaltiesList[0].id,
                    mobile_app_feedback_allowed: 'all-users',
                    mobile_app_feedback_invitation_text: {},
                    mobile_app_feedback_source_id: feedbackSource.id,
                    transaction_feedback_message_delay: 0,
                    transaction_feedback_message_send: 0
                  };
                  FeedbackService.modifyLoyaltyCustomerFeedbackSettings($scope.loyaltiesList[0].id, enableFeedbackParams,
                      function(success, data) {
                        if (success) {
                          FeedbackService.getFeedbackSourceData($scope.loyaltiesList[0].id, feedbackSource.id, function(success, data) {
                            block_wizard.stop();
                            if (success) {
                              $scope.finalFeedbackSourceData = data;
                              $scope.finalFeedbackSourceData.urls.short_url = appConfig.platformParams.business_site.en.includes('test')
                                  ? $scope.finalFeedbackSourceData.urls.short_url
                                  : $scope.finalFeedbackSourceData.urls.short_url.replace('test.', '');
                              $scope.step++;
                            }
                          });
                        } else {
                          $scope.inlineMessage = data.message;
                        }
                      });
                } else {
                  $scope.inlineMessage = data.message;
                }
              });
            } else {
              $scope.inlineMessage = data.message;
              block_wizard.stop();
            }
          });
          break;
      }
    };

    $scope.onCleanInlineMessage = function() {
      $scope.inlineMessage = '';
    };

    initController();

    $rootScope.$watchCollection('[COUNTRIES[LANG], TIMEZONES[LANG]]', function(newCollection, oldCollection, scope) {
      if (newCollection[0]) {
        $scope.data.countriesList = angular.copy($rootScope.COUNTRIES[$rootScope.LANG]);
      }
      if (newCollection[1]) {
        $scope.data.timezonesList = angular.copy($rootScope.TIMEZONES[$rootScope.LANG]);
      }
      if (newCollection[0] && newCollection[1]) {
        var country = itemByIndex($scope.data.countriesList, $scope.createBusinessModel.country);

        if ($scope.createBusinessModel)
          $scope.createBusinessModel.time_zone = itemByIndex($scope.data.timezonesList, country.time_zone).id;
      }
    }, true);

    $scope.$watch('createBusinessModel.country', function(newValue, oldValue) {
      if (newValue && newValue !== oldValue) {
        var country = itemByIndex($scope.data.countriesList, newValue);

        if ($scope.createBusinessModel && itemByIndex($scope.data.timezonesList, country.time_zone))
          $scope.createBusinessModel.time_zone = itemByIndex($scope.data.timezonesList, country.time_zone).id;
      }
    });
  }
})();
